﻿﻿import * as d3 from "d3";
import html2canvas from "html2canvas";
import { saveAs } from 'file-saver';
import { authHeader } from "../../../../javascript/auth-header";
import { nest } from 'd3-collection';


export const gray = "#D5DEE4"
export const blue = "#9ed0e6"
export const green = "#70ad6c"
export const orange = "#FFE6BF"
export const other = "#4034f4"


export async function deleteECRReportImage(fileName, currentDateTime, report_display_id, vintage) {
    let url = "/IRISReportsMicroservice/api/PDF/EarlyCareerReportPDF/delete_image";

    var obj = {};

    obj["display_id"] = report_display_id;
    obj["currentDateTime"] = currentDateTime;
    obj["imageName"] = fileName;
    obj["vintage"] = vintage;
    var headers = authHeader();
    headers.append('Accept', 'application/json'); // This one is enough for GET requests
    headers.append('Content-Type', 'application/json'); // This one sends body
    fetch(url, { method: 'POST', body: JSON.stringify(obj), headers: headers })
}

export const stackedData_NoComparison = (data, subgroups, categoryFieldName, valueFieldName) => {
    let sums = [];

    const transformedData = []
    const groups = [...new Set(data.map((a) => { return a.t_emp; }))].sort();
    groups.forEach(year => {
        var countsForYear = data.filter(y => y.t_emp == year);
        var sum = countsForYear.reduce(function (sum, current) {
            return sum + +(current[valueFieldName]);
        }, 0);
        sums.push(sum);

        let obj = { group: year };
        subgroups.forEach(s => {
            const found = data.filter(x => x.t_emp == year && x[categoryFieldName] == s);
            if (found.length > 0)
                obj[s] = found[0][valueFieldName]
        })
        transformedData.push(obj)
    });

    const columns = ["group"];
    subgroups.forEach(s => {
        columns.push(s);
    });
    transformedData["columns"] = columns;
    //stack the data? --> stack per subgroup
    var stackedData = d3.stack()
        .keys(subgroups)
        (transformedData)

    var max = Math.max(...sums);

    return { groups: groups, stackedData: stackedData, max: max }
}


export const stackedData_ForComparison = (
    categoryFieldName,
    yearFieldName,
    valueFieldName,
    data,
    keys,
    data1,
    data2
) => {
    var groupData = nest()
        .key(function (d) { return d.compareValue + d.t_emp; })
        .rollup(function (d, i) {

            var d2 = { compareValue: d[0].compareValue, t_emp: d[0][yearFieldName] }
            d.forEach(function (d) {
                d2[d[categoryFieldName]] = d[valueFieldName]
            })
            return d2;
        })
        .entries(data)
        .map(function (d) { return d.value; });


    var stack = d3.stack()
    var stackData = stack
        .keys(keys)(groupData)

    var max = 0, maxArray = [];
    var result1 = [], result2 = [];
    //calculate Max value for y-axis
    data1.reduce(function (res, value) {
        if (!res[value.t_emp]) {
            res[value.t_emp] = { t_emp: value.t_emp, sum: 0 };
            result1.push(res[value.t_emp])
        }
        res[value.t_emp].sum += +value[valueFieldName];
        return res;
    }, {});

    data2.reduce(function (res, value) {
        if (!res[value.t_emp]) {
            res[value.t_emp] = { t_emp: value.t_emp, sum: 0 };
            result2.push(res[value.t_emp])
        }
        res[value.t_emp].sum += +value[valueFieldName];
        return res;
    }, {});

    result1.forEach((r, i) => {
        var maxValuForYear = (result2[i].sum > r.sum) ? result2[i].sum : r.sum;
        maxArray.push(maxValuForYear)
    })
    max = Math.max(...maxArray);
    //End---calculate Max value for y-axis


    return {
        stackData: stackData, max: max
    };
}

export const combineDataSets = (dataSet1, dataSet2, compare_measure) => {
    let compare_groups = [];
    if (compare_measure == 1) {
        compare_groups = [1, 0]
    }
    else if (compare_measure == 2) {
        compare_groups = ['F', 'M']
    }

    var data1 = dataSet1.map(function (item) {
        var clone = Object.assign({}, item); // Objects are pass by referenced, hence, you need to clone object
        clone.compareValue = compare_groups[0];
        return clone;
    });

    var data2 = dataSet2.map(function (item) {
        var clone = Object.assign({}, item); // Objects are pass by referenced, hence, you need to clone object
        clone.compareValue = compare_groups[1];
        return clone;
    });

    let data = [];
    data = data.concat(data1, data2);
    return data;
}

export const compareMeasure = (savedValues) => {
    //console.log(savedValues);
    if (savedValues.no_compare)
        return 0;
    else if (savedValues.ecr_award_compare)
        return 1;
    else if (savedValues.gender_compare)
        return 2;

    return 0;
}


export const createStackedChart_NoComparison = (chartDivName, parentWidth, data, subgroups, categoryFieldName, valueFieldName, yAxisLabel, colors) => {
    const transformedWithMax = stackedData_NoComparison(
        data,
        subgroups,
        categoryFieldName,
        valueFieldName
    );
    const margin = { top: 20, right: 175, bottom: 80, left: 120 },
        width = (parentWidth || 800) - margin.left - margin.right,
        height = 420 - margin.top - margin.bottom;

    // append the svg object to the body of the page
    const svg = d3.select(chartDivName)
        .append("svg")
        .attr("width", width + margin.left + margin.right)
        .attr("height", height + margin.top + margin.bottom)
        .append("g")
        .attr("transform",
            "translate(" + margin.left + "," + margin.top + ")");

    // Define the div for the tooltip
    var tooltip = d3.select(chartDivName).append("div")
        .attr("class", "ecr_tooltip")
        .style("opacity", 0);

    // color palette = one color per subgroup
    const colorPastel = d3.scaleOrdinal()
        .domain(subgroups)
        //CURRENTLY IN USE: ["#FFE6BF", "#9ed0e6", "#70ad6c", "#D5DEE4", "#4034f4"]
        .range(colors)


    // Add X axis
    var x = d3.scaleBand()
        .domain(transformedWithMax.groups)
        .range([0, width])
        .padding([0.2]);

    var xAxis = svg.append("g")
        .attr("transform", "translate(0," + height + ")")
        .call(d3.axisBottom(x).tickSize(0).tickPadding(10));

    xAxis.attr("class", "tick_style");

    // Add Y axis
    var y = d3.scaleLinear()
        .domain([0, transformedWithMax.max])
        .range([height, 0]);

    if (chartDivName != "#TeamCompositionChart" && chartDivName != "#PublicationChart")
        svg.append("g")
            .call(d3.axisLeft(y).tickFormat(d => d + "%"));
    else
        svg.append("g")
            .call(d3.axisLeft(y));

    svg.append("g")
        .selectAll("g")
        // Enter in the stack data = loop key per key = group per group
        .data(transformedWithMax.stackedData)
        .enter().append("g")
        .attr("fill", function (d) { return colorPastel(d.key); })
        //Our new hover effects
        .on("mouseover", function (d) {
            const dataValue = d.target.__data__;

            let tooltipHtml = "";
            if (chartDivName == "#AwardCountChart") {
                tooltipHtml = `<b>Year:</b> ${dataValue.data.group}<br/><b>>1 awards:</b> ${d3.format(".0f")(dataValue.data["more than 1"] == null ? 0 : dataValue.data["more than 1"])}%<br/><b>1 award:</b> ${d3.format(".0f")(dataValue.data["1"] == null ? 0 : dataValue.data["1"])}%<br/><b>0 awards:</b> ${d3.format(".0f")(dataValue.data["0"] == null ? 0 : dataValue.data["0"])}%`
            }
            else if (chartDivName == "#AuthorshipChart") {
                tooltipHtml = `<b>Year:</b> ${dataValue.data.group}<br/><b>First Authorship:</b> ${d3.format(".0f")(dataValue.data["First Author"] == null ? 0 : dataValue.data["First Author"])}%<br/><b>Last Authorship:</b> ${d3.format(".0f")(dataValue.data["Last Author"] == null ? 0 : dataValue.data["Last Author"])}%<br/><b>Other Authorship:</b> ${d3.format(".0f")(dataValue.data["Other Publ"] == null ? 0 : dataValue.data["Other Publ"])}%<br/><b>No Authorship:</b> ${d3.format(".0f")(dataValue.data["No Publ"] == null ? 0 : dataValue.data["No Publ"])}%`
            }
            else if (chartDivName == "#PublicationChart") {
                tooltipHtml = `<b>Year:</b> ${dataValue.data.group}<br/><b>High Impact:</b> ${d3.format(".1f")(dataValue.data["high"] == null ? 0 : dataValue.data["high"])}<br/><b>Other:</b> ${d3.format(".1f")(dataValue.data["not_high"] == null ? 0 : dataValue.data["not_high"])}`
            }
            else if (chartDivName == "#TeamCompositionChart") {
                tooltipHtml = `<b>Year:</b> ${dataValue.data.group}<br/><b>Faculty:</b> ${d3.format(".0f")(dataValue.data["faculty"])}<br/><b>Staff:</b> ${d3.format(".0f")(dataValue.data["staff"])}<br/><b>Student:</b> ${d3.format(".0f")(dataValue.data["student"])}<br/><b>Postdoc:</b> ${d3.format(".0f")(dataValue.data["post_doc"])}<br/><b>Unknown:</b> ${d3.format(".0f")(dataValue.data["unknown"])}`
            }
            else if (chartDivName == "#POEChart") {
                tooltipHtml = `<b>Year:</b> ${dataValue.data.group}<br/><b>PI:</b> ${d3.format(".0f")(dataValue.data["avg_poe_pi"])}%<br/><b>Not PI:</b> ${d3.format(".0f")(dataValue.data["avg_poe_not_pi"])}%`
            }

            tooltip.style("opacity", .9);
            //tooltip.transition()
            //    .duration(200)
            //    .style("opacity", .9);
            tooltip.html(tooltipHtml)
                .style("left", (d.layerX) + "px")
                .style("top", (d.layerY) + "px");
        })
        .on("mouseout", function (d) {
            tooltip.transition()
                //.duration(500)
                .style("opacity", 0);
        })
        .selectAll("rect")
        // enter a second time = loop subgroup per subgroup to add all rectangles
        .data(function (d) { return d; })
        .enter().append("rect")
        .attr("x", function (d) { return x(d.data.group); })
        .attr("y", function (d) { return y(d[1]); })
        .attr("height", function (d) { return y(d[0]) - y(d[1]); })
        .attr("width", x.bandwidth());

    //Add Axis Labels
    svg.append("text")
        .attr("text-anchor", "end")
        .attr("x", width / 2)
        .attr("y", height + margin.top + 35)
        .attr("stroke", "#1d2951")
        .attr("stroke-width", "0.1")
        .classed('axis_style', true)
        .text("Data Year");

    if (yAxisLabel.length > 40) {
        var text1 = "Percentage of researchers";
        var text2 = "with types of publications";
        svg.append("text")
            .attr("text-anchor", "end")
            .attr("transform", "rotate(-90)")
            .attr("y", -margin.left + 30)
            .attr("x", -margin.top - 50)
            .attr("stroke", "#1d2951")
            .attr("stroke-width", "0.1")
            .classed('axis_style', true)
            .text(text1)

        svg.append("text")
            .attr("text-anchor", "end")
            .attr("transform", "rotate(-90)")
            .attr("y", -margin.left + 60)
            .attr("x", -margin.top - 50)
            .attr("stroke", "#1d2951")
            .attr("stroke-width", "0.1")
            .classed('axis_style', true)
            .text(text2)

    }
    else {
        svg.append("text")
            .attr("text-anchor", "end")
            .attr("transform", "rotate(-90)")
            .attr("y", -margin.left + 30)
            .attr("x", -margin.top - 90)
            .attr("stroke", "#1d2951")
            .attr("stroke-width", "0.1")
            .classed('axis_style', true)
            .text(yAxisLabel)
    }
    var legend = svg.append('g')
        .attr('class', 'ecr_legend')
        .attr('transform', 'translate(' + (width + 10) + ', 0)');


    const totalItems = subgroups.length + 1;

    legend.selectAll('rect')
        .data(subgroups.reverse())
        .enter()
        .append('rect')
        .attr('x', 0)
        .attr('y', function (d, i) {
            //return (totalItems-i) * 18;
            return i * 18;
        })
        .attr('width', 12)
        .attr('height', 12)
        .attr('fill', function (d, i) {
            return colorPastel(d);
        });

    legend.selectAll('text')
        .data(subgroups)
        .enter()
        .append('text')
        .text(d => legendMap[d])
        .attr('x', 18)
        .attr('y', function (d, i) {
            //return (totalItems-i) * 18;
            return i * 18;
        })
        .attr('text-anchor', 'start')
        .attr('alignment-baseline', 'hanging');

    return svg;
}

export const legendMap = {
    "avg_poe_pi": "PI",
    "avg_poe_not_pi": "Not PI",
    "faculty": "Faculty",
    "staff": "Staff",
    "student": "Student",
    "post_doc": "Postdoc",
    "unknown": "Unknown",
    "more than 1": ">1 awards",
    "1": "1 award",
    "0": "0 awards",
    "Last Author": "Last Authorship",
    "First Author": "First Authorship",
    "Other Publ": "Other Authorship",
    "No Publ": "No Authorship",
    "high": "High Impact",
    "not_high": "Other",

}

const getComparisonString = (value) => {
    if (value == "F" || value == "M")
        return value;
    else if (value == 0)
        return "no";
    else if (value == 1)
        return "yes";

    return "";
}


export const createStackedChart_Comparison = (chartDivName, parentWidth, data1, data2, compare_measure, subgroups, categoryFieldName, valueFieldName, yAxisLabel, colors) => {
    const margin = { top: 50, right: 175, bottom: 60, left: 120 },
        width = (parentWidth || 800) - margin.left - margin.right,
        height = 450 - margin.top - margin.bottom;

    // append the svg object to the body of the page
    const svg = d3.select(chartDivName)
        .append("svg")
        .attr("width", width + margin.left + margin.right)
        .attr("height", height + margin.top + margin.bottom)
        .append("g")
        .attr("transform",
            "translate(" + margin.left + "," + margin.top + ")");
    const data = combineDataSets(data1, data2, compare_measure)

    // Define the div for the tooltip
    var tooltip = d3.select(chartDivName).append("div")
        .attr("class", "ecr_tooltip")
        .style("opacity", 0);

    // color palette = one color per subgroup
    const colorPastel = d3.scaleOrdinal()
        .domain(subgroups)
        //CURRENTLY IN USE: ["#FFE6BF", "#9ed0e6", "#70ad6c", "#D5DEE4", "#4034f4"]
        .range(colors)


    var x0 = d3.scaleBand()
        .rangeRound([0, width])
        .paddingInner(0.1);

    var x1 = d3.scaleBand()
        .padding(0.05);


    var z = d3.scaleOrdinal()
        // orange, blue, green, gray
        //CURRENTLY IN USE: ["#FFE6BF", "#9ed0e6", "#70ad6c", "#D5DEE4", "#4034f4"]
        .range(colors)

    x0.domain(data.map(function (d) { return d.t_emp; }).sort());
    x1.domain(data.map(function (d) { return d.compareValue; }))
        .rangeRound([0, x0.bandwidth()])
        .padding(0.2);

    //z.domain(data.map(function (d) { return d[categoryFieldName]; }))
    z.domain(subgroups);
    var keys = z.domain()

    //const { stackData, max } = stackedData_ForComparison(categoryFieldName, "t_emp", valueFieldName, data, keys, data1, data2);
    const { stackData, max } = stackedData_ForComparison(categoryFieldName, "t_emp", valueFieldName, data, subgroups, data1, data2);

    var y = d3.scaleLinear()
        .domain([0, max])
        .rangeRound([height, 0]);

    if (chartDivName != "#TeamCompositionChart" && chartDivName != "#PublicationChart")
        svg.append("g")
            .call(d3.axisLeft(y).tickFormat(d => d + "%"));
    else
        svg.append("g")
            .call(d3.axisLeft(y));

    //y.domain([0, d3.max(data, function(d) { return d.Value; })]).nice();

    var serie = svg.selectAll(".serie")
        .data(stackData)
        .enter().append("g")
        .attr("class", "serie")
        .attr("fill", function (d) { return z(d.key); });

    serie.selectAll("rect")
        .data(function (d) { return d; })
        .enter().append("rect")
        .on("mouseover", function (d) {
            const dataValue = d.target.__data__;

            let tooltipHtml = "";
            if (chartDivName == "#AwardCountChart") {
                tooltipHtml = `<b>Year:</b> ${dataValue.data["t_emp"]}<br/><b>>1 awards:</b> ${d3.format(".0f")(dataValue.data["more than 1"])}%<br/><b>1 award:</b> ${d3.format(".0f")(dataValue.data["1"])}%<br/><b>0 awards:</b> ${d3.format(".0f")(dataValue.data["0"])}%`
            }
            else if (chartDivName == "#AuthorshipChart") {
                tooltipHtml = `<b>Year:</b> ${dataValue.data.group}<br/><b>Last Authorship:</b> ${d3.format(".0f")(dataValue.data["Last Author"] == null ? 0 : dataValue.data["Last Author"])}%<br/><b>First Authorship:</b> ${d3.format(".0f")(dataValue.data["First Author"] == null ? 0 : dataValue.data["First Author"])}%<br/><b>Other Authorship:</b> ${d3.format(".0f")(dataValue.data["Other Publ"] == null ? 0 : dataValue.data["Other Publ"])}%<br/><b>No Authorship:</b> ${d3.format(".0f")(dataValue.data["No Publ"] == null ? 0 : dataValue.data["No Publ"])}%`
            }
            else if (chartDivName == "#PublicationChart") {
                tooltipHtml = `<b>Year:</b> ${dataValue.data.group}<br/><b>High Impact:</b> ${d3.format(".1f")(dataValue.data["high"] == null ? 0 : dataValue.data["high"])}<br/><b>Other:</b> ${d3.format(".1f")(dataValue.data["not_high"] == null ? 0 : dataValue.data["not_high"])}`
            }
            else if (chartDivName == "#TeamCompositionChart") {
                tooltipHtml = `<b>Year:</b> ${dataValue.data["t_emp"]}<br/><b>Faculty:</b> ${d3.format(".0f")(dataValue.data["faculty"])}<br/><b>Staff:</b> ${d3.format(".0f")(dataValue.data["staff"])}<br/><b>Student:</b> ${d3.format(".0f")(dataValue.data["student"])}<br/><b>Postdoc:</b> ${d3.format(".0f")(dataValue.data["post_doc"])}<br/><b>Unknown:</b> ${d3.format(".0f")(dataValue.data["unknown"])}`
            }
            else if (chartDivName == "#POEChart") {
                tooltipHtml = `<b>Year:</b> ${dataValue.data["t_emp"]}<br/><b>PI:</b> ${d3.format(".0f")(dataValue.data["avg_poe_pi"])}%<br/><b>Not PI:</b> ${d3.format(".0f")(dataValue.data["avg_poe_not_pi"])}%`
            }

            tooltip.style("opacity", .9);

            //tooltip.transition()
            //    .duration(200)
            //    .style("opacity", .9);
            tooltip.html(tooltipHtml)
                .style("left", (d.layerX) + "px")
                .style("top", (d.layerY) + "px");
        })
        .on("mouseout", function (d) {
            tooltip
                //    .transition().duration(500)
                .style("opacity", 0);
        })
        .attr("class", "serie-rect")
        .attr("transform", function (d) { return "translate(" + x0(d.data.t_emp) + ",0)"; })
        .attr("x", function (d) { return x1(d.data.compareValue); })
        .attr("y", function (d) { return y(d[1]); })
        .attr("height", function (d) { return y(d[0]) - y(d[1]); })
        .attr("width", x1.bandwidth())
        .on("click", function (d, i) { console.log("serie-rect click d", i, d); });

    // eca
    if (compare_measure == 1) {
        svg.append("g")
            .selectAll("g")
            .data(stackData)
            .enter()
            .append("g")
            .selectAll("text")
            .data(function (d) { return d; })
            .enter()
            .append("text")
            .attr("transform", function (d) { return "translate(" + x0(d.data.t_emp) + ",0)"; })
            .attr("x", function (d) { return x1(d.data.compareValue) + 10; })
            //.attr("y", function (d) { return y(d[1]) - 25; })
            .attr("y", -30)
            .text((d) => { return (d[0] == 0) ? "ECA" : "" })
            .attr("text-anchor", "middle")

    }

    svg.append("g")
        .selectAll("g")
        .data(stackData)
        .enter()
        .append("g")
        .selectAll("text")
        .data(function (d) { return d; })
        .enter()
        .append("text")
        .attr("transform", function (d) { return "translate(" + x0(d.data.t_emp) + ",0)"; })
        .attr("x", function (d) { return x1(d.data.compareValue) + 10; })
        //.attr("y", function (d) { return y(d[1]) - 10; })
        .attr("y", -14)
        .text((d) => {
            //console.log(d);
            return (d[0] == 0) ? getComparisonString(d.data.compareValue) : ""
        })
        .attr("text-anchor", "middle")



    svg.append("g")
        .attr("class", "axis")
        .attr("transform", "translate(0," + height + ")")
        .call(d3.axisBottom(x0));




    //Add Axis Labels
    svg.append("text")
        .attr("text-anchor", "end")
        .attr("x", width / 2)
        .attr("y", height + margin.top + 5)
        .attr("stroke", "#1d2951")
        .attr("stroke-width", "0.1")
        .classed('axis_style', true)
        .text("Data Year");

    if (yAxisLabel.length > 40) {
        var text1 = "Percentage of researchers";
        var text2 = "with types of publications";
        svg.append("text")
            .attr("text-anchor", "end")
            .attr("transform", "rotate(-90)")
            .attr("y", -margin.left + 30)
            .attr("x", -margin.top - 50)
            .attr("stroke", "#1d2951")
            .attr("stroke-width", "0.1")
            .classed('axis_style', true)
            .text(text1)

        svg.append("text")
            .attr("text-anchor", "end")
            .attr("transform", "rotate(-90)")
            .attr("y", -margin.left + 60)
            .attr("x", -margin.top - 50)
            .attr("stroke", "#1d2951")
            .attr("stroke-width", "0.1")
            .classed('axis_style', true)
            .text(text2)
    }
    else {
        svg.append("text")
            .attr("text-anchor", "end")
            .attr("transform", "rotate(-90)")
            .attr("y", -margin.left + 30)
            .attr("x", -margin.top - 90)
            .attr("stroke", "#1d2951")
            .attr("stroke-width", "0.1")
            .classed('axis_style', true)
            .text(yAxisLabel)
    }

    var legend = svg.append('g')
        .attr('class', 'ecr_legend')
        .attr('transform', 'translate(' + (width + 10) + ', 0)');

    const totalItems = subgroups.length + 1;
    legend.selectAll('rect')
        .data(subgroups.reverse())
        .enter()
        .append('rect')
        .attr('x', 0)
        .attr('y', function (d, i) {
            //return (totalItems-i) * 18;
            return i * 18;
        })
        .attr('width', 12)
        .attr('height', 12)
        .attr('fill', function (d, i) {
            return colorPastel(d);
        });

    legend.selectAll('text')
        .data(subgroups)
        .enter()
        .append('text')
        .text(d => legendMap[d])
        .attr('x', 18)
        .attr('y', function (d, i) {
            //return (totalItems-i) * 18;
            return i * 18;
        })
        .attr('text-anchor', 'start')
        .attr('alignment-baseline', 'hanging');

    return svg;

}

export const filterECRHeading_AndComparison = (selections, suborgNames) => {
    let text = filterECRHeading(selections, suborgNames);

    if (selections && selections.ecr_award_compare || selections.gender_compare) {
        text = text.slice(0, -1);
        text += ", Comparison: ";

        if (selections.gender_compare)
            text += "Gender";
        else
            text += "Early Career Award";

        text += ".";
    }

    return text;
}

export const filterECRHeading = (selections, suborgNames) => {
    let text = "Filters: ";
    //console.log(selections);

    if (selections.ecr_award.length == 0 ||
        (selections.ecr_award.includes('1') && selections.ecr_award.includes('0'))) {
        text = "All award statuses; ";
    }
    else if (selections.ecr_award.includes('1') && !selections.ecr_award.includes('0')) {
        text += "Early Career Award winners; ";
    }
    else if (selections.ecr_award.includes('0') && !selections.ecr_award.includes('1')) {
        text += "Non-Early Career Award winners; ";
    }

    if (selections.gender.length == 0) {
        text += "All genders; ";
    }
    else {
        selections.gender.forEach((f, i) => {
            text += f.replace('F', 'Female').replace('M', 'Male').replace('U', 'Unknown') + ", "
        })
        text = text.slice(0, -2);
        text += "; ";
    }

    if (selections.suborg.length == 0 ||
        (selections.suborg.includes('suborg1')
            && selections.suborg.includes('suborg2')
            && selections.suborg.includes('suborg3')
            && selections.suborg.includes('suborg4')
            && selections.suborg.includes('suborg5')
        )) {
        text += "All academic units; ";
    }
    else {
        selections.suborg.forEach((s, index) => {
            text += suborgNames.filter(n => n.suborg_rank == s.slice(-1))[0].ranked_suborg + ", "
        })
        text = text.slice(0, -2);
        text += "; ";
    }

    if (selections.funder.length == 0 ||
        (selections.funder.includes('NIH')
            && selections.funder.includes('NSF')
            && selections.funder.includes('nonfed')
            && selections.funder.includes('otherfunder')
        )) {
        text += "All funders.";
    }
    else {
        selections.funder.forEach((f, i) => {
            text += f.replace("nonfed","Non-Federal").replace("otherfunder","Other Funder") + ", "
        })
        text = text.slice(0, -2);
        text += ".";
    }


    return text;
}

export const ecrFilterValues = (
    selectionType,
    value,
    suborgs = [],
    suborgsDefined = false
) => {
    if (selectionType == "ecr_award") {
        if (value == "1") {
            return "Early Career Award: Yes";
        }
        else if (value == "0") {
            return "Early Career Award: No";
        }
    }
    else if (selectionType == "gender") {
        if (value == "F") {
            return "Gender: Female";
        }
        else if (value == "M") {
            return "Gender: Male";
        }
        else if (value == "U") {
            return "Gender: Unknown";
        }
    }
    else if (selectionType == "funder") {
        if (value == "NIH") {
            return "Primary Funding Source: NIH";
        }
        else if (value == "NSF") {
            return "Primary Funding Source: NSF";
        }
        else if (value == "nonfed") {
            return "Primary Funding Source: Non-Federal";
        }
        else if (value == "otherfunder") {
            return "Primary Funding Source: Other Funding";
        }
    }
    else if (selectionType == "suborg") {
        if (suborgsDefined) {
            if (value == "suborg1") {
                return `Academic Unit: ${suborgs[0].ranked_suborg}`;
            }
            else if (value == "suborg2") {
                return `Academic Unit: ${suborgs[1].ranked_suborg}`;
            }
            else if (value == "suborg3") {
                return `Academic Unit: ${suborgs[2].ranked_suborg}`;
            }
            else if (value == "suborg4") {
                return `Academic Unit: ${suborgs[3].ranked_suborg}`;
            }
            else if (value == "suborg5") {
                return `Academic Unit: ${suborgs[4].ranked_suborg}`;
            }
        } //else is true just for OSU 
        else {
            return `Academic Unit: ${suborgs[0].ranked_suborg}`;
        }
    }
}

export const exportECRChart = (
    divName,
    imageName,
    EarlyCareerReportState,
    report_display_id,
    currentDateTime,
    exportYesNo,
    vintage
) => {
    const yello = document.querySelector(divName);
    html2canvas(yello).then(canvas => {
        //var a = document.createElement('a');
        const b64toBlob = (b64Data, contentType = '', sliceSize = 512) => {
            const byteCharacters = atob(b64Data);
            const byteArrays = [];

            for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
                const slice = byteCharacters.slice(offset, offset + sliceSize);

                const byteNumbers = new Array(slice.length);
                for (let i = 0; i < slice.length; i++) {
                    byteNumbers[i] = slice.charCodeAt(i);
                }

                const byteArray = new Uint8Array(byteNumbers);
                byteArrays.push(byteArray);
            }

            const blob = new Blob(byteArrays, { type: contentType });
            return blob;
        }

        let dataURL = canvas.toDataURL("image/png");
        const blob = b64toBlob(dataURL.substring(22), "image/png");
        var university = "";//NewEmployeeReportState.EmployeeProfileInfo.university;
        var start_year = "";//NewEmployeeReportState.EmployeeMethodology.start_year;
        var end_year = "";//NewEmployeeReportState.EmployeeMethodology.end_year;

        let form = new FormData();
        form.append('image', blob, imageName);
        form.append("display_id", report_display_id);
        form.append("currentDateTime", currentDateTime);
        form.append("vintage", vintage);

        form.append("university", university);
        form.append("start_year", start_year);
        form.append("end_year", end_year);

        var headers = authHeader();
        let url = "/IRISReportsMicroservice/api/PDF/EarlyCareerReportPDF/send_image";

        fetch(url, { method: 'POST', body: form, headers: headers }).then(res => {
            return res.blob();
        })
            .then(blob => {
                if (exportYesNo == "yes")
                    saveAs(blob, imageName);
            }).catch((error) => {
            console.log(error);
        })
    })



}

const formatGenerator = d3.format(",.0f");
const getFormat = (units) => {
    return units ?
        (d) => `${formatGenerator(d)}${units}` :
        formatGenerator;
};

export const ColorLookup = {
    assistant: blue,
    promoted: green,
    unobserved: gray
}

const colorGenerator = d3.scaleOrdinal(d3.schemeAccent);
const color = (d) => {
    return ColorLookup[d.name.slice(0, -2)];
};

export { getFormat, color };